export default __webpack_public_path__ + "static/media/ilian_s.0c938d7b.jpg";